module.exports = __webpack_public_path__ + "img/first-image.d994d239.png";